<template lang="pug">
  div
    .mb-5
      b-form-textarea.mb-2(no-resize, rows="1", max-rows="6", v-model="answer_data.text", placeholder="Respuesta")
      .d-flex.align-items-end.justify-content-between
        b-button(variant="light", size="sm", style="border-radius: 20px;", @click="update_answer_id = '';$refs.input_image.click()", v-if="!answer_data.image")
          camera-icon.mr-2.icon-sm
          span.text-sm Imagen
        img-input(v-else, :src="answer_data.image", @click="answer_data.image = ''")
        b-button(variant="success", :disabled="empty_answer", size="sm", @click="addAnswer")
          b-spinner(small, v-if="loading", type="grow")
          span(v-else) Agregar Respuesta
    .d-flex.align-items-center.mb-3(v-if="answers.length")
      span.mr-2 {{ answers.length }} respuestas guardadas:
      b-spinner(variant="primary", small, v-if="loading_update")
    p.mb-0.text-secondary(v-else) No has agregado respuestas para comentarios {{ sentimentName }}
    .overflow-y.scrollable-area(style="max-height: 250px")
      b-card.card-inactive(v-for="(ans, ans_index) in answers", :key="ans.answer_id", :class="ans_index == answers.length - 1 ? 'mb-0' : ''")
        b-form-textarea.mb-2(no-resize, rows="1", max-rows="3", v-model="ans.text", placeholder="Respuesta")
        b-row.justify-content-between.align-items-end
          b-col
            img-input(:src="ans.image", v-if="ans.image != ''", @click="ans.image = ''", size="sm")
            b-button.d-flex.align-items-center(variant="light", size="sm", v-else, style="border-radius:20px;", @click="loadAnswerImage(ans.answer_id)")
              camera-icon.icon-sm.mr-1
              span.text-sm Imagen
          b-col.mt-1(cols="auto")
            b-button.mr-2(variant="soft-danger", size="sm", @click="deleteAnswers(ans.answer_id)", v-b-tooltip.hover="'Eliminar respuesta'")
              trash-2-icon.icon-sm
            b-button(variant="soft-primary", size="sm", @click="postAnswer(ans)") Guardar
    input(type="file", accept="image/*", style="display:none;", ref="input_image", @change="imageSelected($event)")
</template>

<script>
  import { createNamespacedHelpers, mapActions } from 'vuex'
  const answerController = createNamespacedHelpers('answer')
  import ImgInput from './img-input'

  import { UploadFile } from '@/helpers/upload-file'

  export default {
    data () {
      return {
        answer_data: {
          text: '',
          image: '',
          file_image: '',
        },
        update_answer_id: '',
        loading: false,
        loading_update: false
      }
    },
    methods: {
      ...mapActions(['answer/create', 'answer/update', 'answer/destroy', 'helpers/upload_file']),
      async imageSelected (event) {
        let files = event.target.files

        if(files.length) {
          let file = files[0]
          try {
            if(this.update_answer_id != ''){
              let self = this
              let update_answer =  this.post_answers.find(a => a.answer_id == self.update_answer_id)
              update_answer.image = URL.createObjectURL(file)
              update_answer.file_image = file
            } else {
              this.answer_data.image = URL.createObjectURL(file)
              this.answer_data.file_image = file
            }
          } catch (e) {
            console.log(e)
            this.$message.warning('No logramos crear la vista previa de la imagen, por favor comprueba tu conexión a internet');            
          }
          this.$refs.input_image.value = ''
        }
      },
      loadAnswerImage(answer_id){
        this.update_answer_id = answer_id
        this.$refs.input_image.click()
      },
      addAnswer () {
        let data = Object.assign({}, this.answer_data)
        data.sentiment = this.sentiment
        this.postAnswer(data)
      },
      postAnswer (data) {
        data.answer_id ? this.updateAnswer(data) : this.createAnswer(data)
      },
      async createAnswer (data) {
        var self = this
        this.loading = true

        if (data.file_image != '' && Object.keys(data.file_image).length) {
          try {
            let res = await UploadFile.call(this, data.file_image)
            data.image = res
          } catch (e) {
            this.$message.error(e.message)
          }
        }

        let json_data = {
          platform: 'facebook',
        	text: data.text,
        	image: data.image || null,
          post_id: this.post_id,
          sentiment: data.sentiment,
        };

        this['answer/create']({
          ...json_data,
          callback: res => {
            self.loading = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$message.success('Respuesta creada')
              self.clearObject(self.answer_data)
            }
          }
        })
      },
      async updateAnswer (data) {
        var self = this
        this.loading_update = true

        if (data.file_image && data.file_image != '') {
          try {
            let res = await UploadFile.call(this, data.file_image)
            data.image = res
          } catch (e) {
            this.$message.error(e.message)
          }
        }

        let json_data = {
          platform: 'facebook',
          text: data.text,
          image: data.image || null,
          post_id: this.post_id,
          sentiment: data.sentiment,
          answer_id: data.answer_id
        };

        this['answer/update']({
          ...json_data,
          callback: res => {
            self.loading_update = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$message.success('Respuesta actualizada')
            }
          }
        })
      },
      deleteAnswers (answer_id) {
        var self = this
        this['answer/destroy']({
          answer_id: answer_id,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            } else {

            }
          }
        })
      },
    },
    props:{
      post_answers: {
        type: Array,
        default: function () {
          return []
        }
      },
      sentiment: {
        type: String,
        default: 'positive'
      },
      post_id: {
        default: null
      }
    },
    computed: {
      empty_answer () {
        return !this.answer_data.text.length
      },
      answers () {
        let self = this
        return this.post_answers.filter(a => a.sentiment == self.sentiment)
      },
      sentimentName () {
        switch (this.sentiment) {
          case 'positive':
            return 'positivos'
            break
          case 'negative':
            return 'negativos'
            break
          case 'neutral':
            return 'neutrales'
            break
          default:
            return '--'
        }
      }
    },
    mounted () {

    },
    watch: {

    },
    components: { ImgInput }
  }
</script>

<style lang="scss" scoped>
  .absolute {
    position: absolute;
  }

  .delete-ans {
    position: absolute;
    top: 5px;
    right: 5px;
  }
</style>
